<template>
  <div class="calico-close-chat">
    <div style="width: fit-content;">
      <button
        class="button-tertiary--small"
        v-bind="$attrs"
      >
        <i class="bi bi-caret-down-fill" />
        View Profile
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoCloseChat",
};
</script>

<style scoped lang="scss">
.calico-close-chat {
  @include stack-space($space-small);
  padding: $space-xsmall $space-medium;
  padding-bottom: $radius-large;
  align-items: center;
}
</style>
